<section class="main-section d-flex py-2 zoom-scope" [ngStyle]="styles" [ngClass]="{
     'align-items-start': sectionMain.elementPosition == 'TOPO',
    'align-items-center': sectionMain.elementPosition == 'CENTRO',
    'align-items-end': sectionMain.elementPosition === 'BASE',
  }">
  <div class="container d-flex flex-column" [ngClass]="{ 'text-center': true }">
    <h1 class="pb-3 d-flex flex-column">
      <span class="prefixo">{{componentData.prefixo}}
        <span *ngIf="sectionMain.hasCounter" class="highlight">
          <span class="specialCharacter">{{componentData.specialCharacter}}</span>
          {{componentData.highlight}}</span>
      </span>
      <span class="sufixo">{{componentData.sufixo}}</span>
    </h1>
    <p *ngIf="sectionMain.hasSubtitle" class="pb-5 px-4 subtitle">{{componentData.subtitle}}</p>
    <!-- <app-button class="btn-joinplan" *ngIf="sectionMain.hasJoinPlanButton" [buttonOptions]="buttonOptions" routerLink="/cadastro-socio">
    </app-button> -->

    <div class="button-finaly " *ngIf="sectionMain.hasJoinPlanButton">
       <button class="btn-joinplan"  (click)="goToRegister()">QUERO SER SÓCIO</button>
    </div>

    <app-button class="mt-2 d-md-none" [buttonOptions]="loginButtonOptions" routerLink="/login">
    </app-button>
  </div>

  <!-- Controles -->
    <a *ngIf="images.length > 1"
      class="carousel-control-prev"
      href="#carouselBanners"
      role="button"
      data-bs-slide="prev"
      (click)="goToPrevImage()">
      <span  id="carousel-control-prev-icon" aria-hidden="true"><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
      <span class="visually-hidden">Anterior</span>
    </a>
    <a *ngIf="images.length > 1"
      class="carousel-control-next"
      href="#carouselBanners"
      role="button"
      data-bs-slide="next"
      (click)="goToNextImage()">
      <span id="carousel-control-next-icon" aria-hidden="true"><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
      <span class="visually-hidden">Próximo</span>
    </a>
</section>
